import React from 'react';
import { titleStyle } from '../Shared/Styles';

function Title(props) {
    const renderComponent = (component) => {
        switch (component) {
            case 'request-policy-documents':
                return (
                    <span>Request Policy Documents for Policy</span>
                );

            case 'alter-policy':
                return (
                    <span>Policy Alteration for Policy</span>
                );

            case 'policy-exclusions-and-loadings':
                return (
                    <span>Policy exclusions and loadings for policy</span>
                );

            case 'payment-details':
                return (
                    <span>Payment Details for Policy</span>
                );

            case 'beneficiaries':
                return (
                    <span>Beneficiaries for Policy</span>
                );

            case 'request-existing-business-quote':
                return (
                    <span>Request Existing Business Quote</span>
                );
              
            case 'request-certificate-of-currency':
                return (
                    <span></span>
                );

            case 'request-policy-summary':
                return (
                    <span></span>
                );

            default: return (
                <span data-testid="productName">{props.productName} | </span>
            );
        }
    }

    if (props.endCrumb === "request-certificate-of-currency" || props.endCrumb === "request-policy-summary") {
        return (
            <></>
        )
    } else {
        return (
            <h1 style={titleStyle} className="Title">
                {renderComponent(props.endCrumb)} <span data-testid="policyNumber">{props.policyNumber}</span>
            </h1>
        )
    }
}

export default Title;